import React from "react";
export default class VenueIcon extends React.Component {
    render() {
        return (<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect x="1" y="2.42725" width="14" height="11.3333" rx="1.75" stroke="#0C172F" strokeWidth="1.16667"/>
				<path fillRule="evenodd" clipRule="evenodd" d="M6 5.42725V10.7606L10.6667 8.06071L6 5.42725Z" stroke="#0C172F" strokeWidth="1.16667" strokeLinejoin="round"/>
			</svg>);
    }
}
